var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      staticStyle: { "border-radius": "32px !important" },
      attrs: {
        value: _vm.open,
        "max-width": "441",
        width: "441",
        persistent: true
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "dialog-box" },
        [
          _c("div", { staticClass: "header-container" }, [
            _c("span", { attrs: { id: "loginTitle" } }, [
              _vm._v(_vm._s(_vm.$t("Activate2FA")))
            ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "twoFaMessage", attrs: { id: "loginMessage" } },
              [_vm._v(_vm._s(_vm.$t("Activate2FAAuthenticationMessage")))]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "qr-code-container" }, [
            _vm.qrCode
              ? _c("img", {
                  staticClass: "data-image",
                  attrs: { src: _vm.qrCode, alt: "Image icon" }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px", "text-align": "start" } },
            [
              _c("span", { staticClass: "login-input-label" }, [
                _vm._v(_vm._s(_vm.$t("Key")))
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.key,
                    expression: "key"
                  }
                ],
                staticClass: "twoFaInput",
                class: { fieldErrorInput: !_vm.key },
                attrs: { type: "text", id: "key" },
                domProps: { value: _vm.key },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.key = $event.target.value
                  }
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "card-buttons-container" },
            [
              _c("management-button", {
                attrs: {
                  type: "cancel",
                  label: _vm.$t("Cancel"),
                  disabled: _vm.loading || _vm.cancelButtonIsDisabled
                },
                on: { buttonClick: _vm.closeDialog }
              }),
              _vm._v(" -->\n\n      "),
              _c("management-button", {
                attrs: {
                  type: "execute",
                  label: _vm.$t("Confirm"),
                  disabled: !(_vm.key && _vm.secret),
                  "is-loading": _vm.loading
                },
                on: { buttonClick: _vm.confirmAuthenticate }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e7c1590", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e7c1590","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Navbar/UserWindow/ActivateTwoAuthenticationDialog.vue
// module id = null
// module chunks = 